<template>
  <v-layout justify-end>
    <!-- <v-btn outline slot="activator" color="primary" class="mb-2" @click="open">
      <v-icon dark left>note_add</v-icon>New Item
    </v-btn> -->
    <v-dialog v-model="localDialog" persistent max-width="500px" scrollable>
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container fluid>
            <v-layout align-space-around justify-center column>
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-text-field
                  label="Name"
                  v-model="local.name">
                </v-text-field>
                <v-text-field
                  label="File Name"
                  v-model="local.filename">
                </v-text-field>
                <v-text-field
                  label="Service"
                  v-model="local.service">
                </v-text-field>
                <v-textarea
                  label="Description"
                  v-model="local.description">
                </v-textarea>
                <audio-uploader
                  @input="assignAudio"
                  v-model="local.audio">
                  <div slot="activator">
                    <v-text-field
                      label="Upload Audio"
                      v-model='local.audio.audioName'
                      disabled prepend-icon='attach_file'>
                    </v-text-field>
                  </div>
                </audio-uploader>
                <div v-if="local.audio">
                  <div v-if="local.audio.audioURL">
                    <vuetify-audio :file=local.audio.audioURL></vuetify-audio>
                  </div>
                </div>
              </v-form>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outline @click="close">Cancel</v-btn>
          <v-btn  v-if="showSaveButton"  color="primary" @click="save">
            <v-flex v-if="this.saving">
              <v-progress-circular
                indeterminate
                color="primary">
              </v-progress-circular>
            </v-flex>
            <v-flex v-else>Save</v-flex>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import VuetifyAudio from 'vuetify-audio'
import AudioUploader from '../uploader/audioUploader'

export default {
  name: 'addVoice',
  components: { AudioUploader, VuetifyAudio },
  data: () => ({
    valid: true,
    animations: [],
    sounds: [],
    saving: false,
    local: {
      id: null,
      name: '',
      filename: '',
      audio: {
        audioName: '',
        audioFile: '',
        audioURL: ''
      },
      service: ''
    }
  }),
  props: {
    dialog: '',
    editedID: '',
    showSaveButton: true,
    info: {
      id: null,
      name: '',
      filename: '',
      audio: {
        audioName: '',
        audioFile: '',
        audioURL: ''
      },
      service: ''
    }
  },
  computed: {
    formTitle () {
      return this.editedID === -1 ? 'New Voice' : this.showSaveButton ? 'Edit Voice' : 'Preview Voice'
    },
    localDialog: {
      get: function () {
        return this.dialog
      }
    }
  },
  watch: {
    info (val) {
      this.local = Object.assign({}, val)
    },
    dialog (val) {
      if (!val) {
        this.saving = false
      }
    }
  },
  methods: {
    assignAudio (payload) {
      this.local.audio = payload
    },
    open () {
      this.$emit('open')
    },
    close () {
      this.$emit('close')
    },
    save () {
      this.saving = true
      this.$emit('save', this.local)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/assets/add-new/addVoice.vue